import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';

import { LoginLoc } from '../../loc/login';
import { loc } from '../../lib/loc';
import { useStores } from '../../hooks/use-stores';

import { H4 } from '../Header';
import ErrorMessage from '../../interface/ErrorMessage';
import PreloadButton from '../../interface/PreloadButton';
import InputWithCountrySelect from '../UI/InputWithCountrySelect';

const RecoveryForm = observer(() => {
    const { RecoveryStore: store } = useStores();
    const [phone, setPhone] = useState('');
    const { loader, errorMessage, token, recoverPassword } = store || {};

    const submit = e => {
        e.preventDefault();
        recoverPassword(phone);
    };

    return (
        <div className="pb-150 pt-80">
            <div className="login-form" style={{ maxWidth: '470px', margin: 'auto' }}>
                <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', maxWidth: '330px' }}>
                    <H4>{loc(LoginLoc.recoveryFormTitle)}</H4>
                    {token && <Redirect to={'/login/recovery/accept/'} />}
                    {errorMessage && <ErrorMessage message={errorMessage} />}
                    <div className="login-form__wrap-items" style={{ width: '90%', alignSelf: 'center' }}>
                        <InputWithCountrySelect setPhone={setPhone} placeholder={loc(LoginLoc.loginPlaceholder)} />
                    </div>

                    <div className="login-form__wrap-login-btn">
                        <PreloadButton className="login-form__login-btn" isLoad={loader}>
                            {loc(LoginLoc.recoveryButton)}
                        </PreloadButton>
                    </div>
                </form>
            </div>
        </div>
    );
});

export default RecoveryForm;
